<template>
  <el-form label-position="right" label-width="80px" size="mini">
    <el-row style="margin:0;">
      <el-col :span="12">
        <el-form-item label="设备列表">
          <el-select placeholder="下拉查看" v-model="selectValue">
            <el-option v-for="(item,idx) in data.device_list" :key="idx" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="执行操作">
          <el-tag :style="tagStyle">{{data.command?data.command:"无数据"}}</el-tag>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="data.command=='录音'" style="margin:0;">
      <el-col :span="12">
        <el-form-item label="录音频率">
          <el-tag :style="tagStyle">{{data.freq_range?data.freq_range:"无数据"}}</el-tag>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="录音时长">
          <el-tag :style="tagStyle">{{ data.recording_length?`${data.recording_length}秒`:"无数据" }}</el-tag>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row style="margin:0;">
      <el-col :span="12">
        <el-form-item label="创建时间">
          <el-tag :style="tagStyle">{{data.create_time?data.create_time:"无数据"}}</el-tag>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="完成时间">
          <el-tag :style="tagStyle">{{data.finish_time?data.finish_time:"无数据"}}</el-tag>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row style="margin:0;">
      <el-form-item label="任务说明">
        <el-tag :style="tagStyle">{{ data.detail?data.detail:"无说明" }}</el-tag>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
  export default {
    props: ["realtimeTaskId"],
    components: {},
    watch: {
      realtimeTaskId() {
        this.getData();
      }
    },
    mounted() {
      this.getData();
    },
    data() {
      return {
        selectValue: null,
        taskVisible: false,
        data: {},
        tagStyle: "background-color:#fff;color:#999;height:22px;line-height:20px;"
      };
    },
    methods: {
      getData() {
        if (this.realtimeTaskId) {
          this.$getJSON("/task/s_realtime_tasklst", {
            options: [{
              type: "1",
              name: "id",
              value: this.realtimeTaskId
            }]
          }).then(res => {
            this.data = res.data[0];
          });
        }
      },
      parseFreqRange(range) {
        if (range.length == 1) {
          return `${range[0]}`;
        } else {
          return `${range[0]}-${range[1]}`;
        }
      }
    }
  };

</script>

<style scoped>
  .el-form-item {
    margin: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Form/RealtimeTaskDetail.vue